import { render, staticRenderFns } from "./RentContracts.vue?vue&type=template&id=5c0b463a"
import script from "./RentContracts.vue?vue&type=script&lang=js"
export * from "./RentContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports